import { cn } from '@/lib/cn';

/**
 * Raydius: an R, an origin, and a radius. Original single-color vector mark.
 */
export function LogoMark({ size = 28, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden className={cn('text-accent', className)}>
      <path d="M25.5 10A11 11 0 1 0 26.8 19" stroke="currentColor" strokeWidth="1.8" />
      <path d="M10 23V9h6a5 5 0 0 1 0 10h-6m6 0 7 8" stroke="currentColor" strokeWidth="2.5" strokeLinejoin="round" />
      <path d="m16 16 12-12" stroke="currentColor" strokeWidth="1.3" />
      <circle cx="16" cy="16" r="2" fill="currentColor" />
      <circle cx="28" cy="4" r="1.7" fill="currentColor" />
    </svg>
  );
}

export function Wordmark({ className }: { className?: string }) {
  return <span className={cn('raydius-wordmark text-[23px] text-fg', className)}>raydius<span className="text-accent">.</span></span>;
}

export function Logo({ className, mark = 26 }: { className?: string; mark?: number }) {
  return (
    <span className={cn('inline-flex items-center gap-1.5', className)}>
      <LogoMark size={mark} />
      <Wordmark />
    </span>
  );
}

